/* dakotatin-attribution-capture.js
 * Captures Google Ads gclid + utm_* params on first visit, persists 90d,
 * and stages them on window.DTAttribution for the cart-update code to read.
 *
 * INSTALL:
 *   1. Upload as theme asset (Online Store > Themes > Edit code > Assets > Add new asset)
 *   2. In theme.liquid, just before </body>, add:
 *      {{ 'dakotatin-attribution-capture.js' | asset_url | script_tag }}
 *      {{ 'dakotatin-attribution-cart.js'    | asset_url | script_tag }}
 *      {{ 'dakotatin-lead-events.js'         | asset_url | script_tag }}
 *
 * Created: 2026-05-28
 * Modified: 2026-05-28
 */
(function () {
  var STORAGE_KEY = 'dt_attribution';
  var TTL_DAYS = 90;
  var now = Date.now();
  var params = new URLSearchParams(window.location.search);

  // 1. Read existing stored attribution (if fresh)
  var stored = {};
  try {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      var parsed = JSON.parse(raw);
      if (parsed.ts && (now - parsed.ts) < TTL_DAYS * 86400000) {
        stored = parsed.data || {};
      }
    }
  } catch (e) {}

  // 2. Pull fresh attribution from URL (takes precedence over stored)
  var fresh = {};
  var urlGclid = params.get('gclid');
  if (urlGclid) fresh.gclid = urlGclid;
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
    if (params.get(k)) fresh[k] = params.get(k);
  });

  // 3. Fall back to Google's own _gcl_aw cookie for gclid if URL had none
  if (!fresh.gclid) {
    var m = document.cookie.match(/_gcl_aw=([^;]+)/);
    if (m) {
      var parts = decodeURIComponent(m[1]).split('.');
      if (parts.length >= 3) fresh.gclid = parts[2];
    }
  }

  // 4. Merge fresh over stored (last-touch wins for utm, first-touch for gclid if no new one)
  var merged = Object.assign({}, stored, fresh);
  if (Object.keys(merged).length) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: now, data: merged }));
    } catch (e) {}
  }

  // 5. Expose globally for the cart-update + lead-event scripts
  window.DTAttribution = merged;
})();
